import { render, staticRenderFns } from "./DetailsTransaction.vue?vue&type=template&id=a0ce4a7c"
import script from "./DetailsTransaction.vue?vue&type=script&lang=js"
export * from "./DetailsTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports